import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import s from './AppShell.module.css';
import { ErrorBoundary } from './ErrorBoundary';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { ToastHost } from './ToastHost';
import { useIsMobile } from '@/lib/useMediaQuery';
import { useUnreadCount } from '@/api/useNotifications';
import { OgAuthProvider } from '@/api/opengater/OgAuthContext';
import { CurrentUserProvider } from '@/auth/CurrentUserContext';
export function AppShell() {
    return (_jsx(CurrentUserProvider, { children: _jsx(OgAuthProvider, { children: _jsx(AppShellContent, {}) }) }));
}
function AppShellContent() {
    const isMobile = useIsMobile();
    const [collapsed, setCollapsed] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    // Re-key the page-level boundary on navigation so that if a page
    // crashed, navigating elsewhere via the sidebar resets the boundary
    // automatically — the user doesn't have to click "Try again" first.
    const location = useLocation();
    // Reset scroll to the top on every route change — otherwise a deep-scrolled
    // page keeps its offset when you switch sections.
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0 });
    }, [location.pathname]);
    // Panels that span the content area (SidePanel) start where the rail ends.
    const railCollapsed = collapsed && !isMobile;
    useEffect(() => {
        document.documentElement.dataset.sidebar = railCollapsed ? 'collapsed' : 'full';
    }, [railCollapsed]);
    // The Opengater section has no panel backend of its own (and in dev the
    // backup backend is often absent) — don't poll panel notifications there.
    const inOpengater = location.pathname === '/opengater' || location.pathname.startsWith('/opengater/');
    const unreadQ = useUnreadCount({ enabled: !inOpengater });
    const unread = unreadQ.data?.unread ?? 0;
    return (_jsxs("div", { className: s.root, children: [_jsx(Sidebar, { collapsed: railCollapsed, onCollapse: () => (isMobile ? setMobileOpen(false) : setCollapsed((v) => !v)), mobileOpen: mobileOpen, onMobileClose: () => setMobileOpen(false), unreadNotifications: unread }), _jsxs("div", { className: s.main, children: [_jsx(Topbar, { onSidebarOpen: () => setMobileOpen(true) }), _jsx("main", { className: s.content, children: _jsx(ErrorBoundary, { level: "page", children: _jsx(Outlet, {}) }, location.pathname) })] }), _jsx(ToastHost, {})] }));
}
